import styled from '@emotion/styled'
import type { ButtonHTMLAttributes } from 'react'
import React from 'react'

import { getColor, SpacingSize, theme } from '../../Theme'
import LoadingIndicator from '../LoadingIndicator'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode
  submitting?: boolean
  onClick?: () => void
  spacing?: SpacingSize
}

const Button = styled.button<Props>`
  ${theme.text('mediumSmall', 'content', 'bold')};
  color: ${(p) => {
    const baseColor = p.disabled ? 'primaryBlueDisabled' : 'primaryBlue'
    return getColor(p.theme, [baseColor], [baseColor])
  }};
  background: transparent;
  border: none;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  ${({ spacing }) => theme.spacing.all(spacing || 'small')};
  width: fit-content;
`

const LoadingIndicatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sizes.tiny};
`

export const TransparentButton = ({ children, onClick, submitting, ...props }: Props) => (
  <Button onClick={onClick} disabled={props.disabled || submitting} {...props}>
    {
      <LoadingIndicatorContainer>
        {children}
        {submitting && <LoadingIndicator size="small" />}
      </LoadingIndicatorContainer>
    }
  </Button>
)

export default TransparentButton
